module.exports = __webpack_public_path__ + "static/media/logo.ab4989f1.jpg";